<body>
  <lib-logo variant="normal" size="medium" [customWidth]="'105.6px'" class="img-logo"></lib-logo>
  <div class="session">
    <form class="account-blocked-form" autocomplete="off">
      <h4>Account Blocked</h4>
      <span>
        Please request for unblock by sending an email to:
        <br />
        helpdesk&#64;pivot-payment.com</span
      >
      <button [routerLink]="['/login']" type="submit">Close</button>
    </form>
  </div>
</body>
